'use client'

import Cookies from 'js-cookie'

declare global {
	interface Window {
		gtag
		dataLayer
	}
}

export function pageView (): void {
	const data = {
		event: 'page_view',
	}

	if (process.env.NODE_ENV === 'development') {
		console.log('gtm:pageView', data)
	}

	if (window.dataLayer) window.dataLayer.push(data)
}

type EventOptions = {
	customer_id?: string
	content_id?: string
	content_type?: string
	element_id?: string
	element_type?: string
	element_text?: string
	link_url?: string
	cta_name?: string
	ecommerce?
	listId?: string
}

export async function event (event: 'view_content' | 'search' | 'click_menu' | 'click_cta' | 'view_item' | 'select_item' | 'add_to_cart' | 'newsletter_signup' | 'initiate_checkout' | string, options: EventOptions) {
	const data = {
		event,
		...options,
	}

	if (process.env.NODE_ENV === 'development') {
		console.log('gtm:event', data)
	}

	if (window.dataLayer) window.dataLayer.push(data)
}

type CookieFirstConsent = {
	necessary: boolean
	functional: boolean
	performance: boolean
	advertising: boolean
}

export const DEFAULT_CONSENT: CookieFirstConsent = {
	necessary: true,
	functional: false,
	performance: false,
	advertising: false,
}

// const currentConsent = {current: DEFAULT_CONSENT}

export function initConsent (preconsent: CookieFirstConsent) {
	// retrieve saved configuration from cookies
	const savedConsent = Cookies.get('cookiefirst-consent')
	const consent: CookieFirstConsent = savedConsent ? JSON.parse(savedConsent) : preconsent

	if (window.gtag) window.gtag('set', 'ads_data_redaction', consent.advertising)

	return {consent: updateConsent(consent, {state: 'default', save: false}), restored: !!savedConsent}
}

export function updateConsent (consent: CookieFirstConsent, options = {state: 'update', save: true}) {
	const denied = 'denied'
	const granted = 'granted'

	// map to GTM consent mode model
	const gtmConsent = {
		security_storage: granted,
		analytics_storage: consent.performance ? granted : denied,
		functionality_storage: consent.functional ? granted : denied,
		ad_storage: consent.advertising ? granted : denied,
		personalization_storage: consent.functional ? granted : denied,
	}

	if (window.gtag) {
		window.gtag('consent', options.state, gtmConsent)
	}

	const keys = ['necessary', 'functional', 'performance', 'advertising']
	for (const key in consent) {
		if (keys.includes(key)) event(`cf_consent_${key}`, {[`cf_${key}_enabled`]: consent[key]})
	}

	if (options.save) {
		Cookies.set('cookiefirst-consent', JSON.stringify({...consent, timestamp: Date.now()}))
	}

	// currentConsent.current = consent

	return consent
}

export function acceptAllConsent () {
	updateConsent({
		necessary: true,
		functional: true,
		performance: true,
		advertising: true,
	})
}
